import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEqualsLess(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19 7C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5L5 5C4.44772 5 4 5.44771 4 6C4 6.55228 4.44772 7 5 7L19 7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29289 11.2929C4.90237 11.6834 4.90237 12.3166 5.29289 12.7071L11.2929 18.7071C11.6834 19.0976 12.3166 19.0976 12.7071 18.7071L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929C18.3166 10.9024 17.6834 10.9024 17.2929 11.2929L12 16.5858L6.70711 11.2929C6.31658 10.9024 5.68342 10.9024 5.29289 11.2929Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
